import React, { useState } from "react";
import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";
import { ValmetGrey14, ValmetGreen1 } from "theme";
import { Link, useRouteMatch } from "react-router-dom";
import { Tab } from "models";
import { Typography } from "@material-ui/core";

const localStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectedTabLabel: {
      color: ValmetGreen1,
    },
    selectedTab: {
      backgroundColor: "white",
    },
    unselectedTab: {
      backgroundColor: "#f6f7f8",
    },
    tabList: {
      display: "flex",
      listStyleType: "none",
      margin: "0",
      padding: "0",
      overflow: "hidden",
    },
    listElement: {
      justifyItems: "center",
      border: "1px solid " + ValmetGrey14,
      borderBottom: "unset",
      borderRadius: "4px 4px 0px 0px",
      cursor: "pointer",
      marginRight: "2px",
      [theme.breakpoints.down("sm")]: {
        marginRight: "unset",
      },
    },
    link: {
      display: "block",
      textAlign: "center",
      padding: "10px",
      textDecoration: "none",
      "&:link": {
        color: "initial",
      },
      "&:visited": {
        color: "initial",
      },
      "&:hover": {
        color: "initial",
      },
    },
  }),
);

const initialTabs = [
  { id: "fuelcomposition", title: "Fuel Composition", target: "/fuel-composition", selected: true },
  { id: "damperpositions", title: "Damper Positions", target: "/damper-positions", selected: false },
  { id: "startupburner", title: "Startup Burner Override", target: "/startup-burner-override", selected: false },
  { id: "logs", title: "Logs", target: "/logs", selected: false },
];

const TabPanel: React.FC = () => {
  const localClasses = localStyles();
  let { url } = useRouteMatch();

  const [tabs, setTabs] = useState<Tab[]>(initialTabs);

  const handleSwitchTab = (tabId: string) => {
    const newTabs = tabs.map((tab) => {
      return { ...tab, selected: tab.id === tabId };
    });

    setTabs(newTabs);
  };

  return (
    <nav>
      <ul className={localClasses.tabList}>
        {tabs.map((tab) => {
          return (
            <li
              key={tab.id}
              className={
                tab.selected
                  ? `${localClasses.listElement} ${localClasses.selectedTab}`
                  : `${localClasses.listElement} ${localClasses.unselectedTab}`
              }
            >
              <Link to={`${url}${tab.target}`} className={localClasses.link} onClick={() => handleSwitchTab(tab.id)}>
                <Typography variant="body2" className={tab.selected ? `${localClasses.selectedTabLabel}` : ``}>
                  {tab.title}
                </Typography>
              </Link>

            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default TabPanel;
